import { c as _c } from "react/compiler-runtime";
import type { PlayInfo } from '@module/apis/client-side/live/type';
import ChatEmoticonSelectBox from '@module/components/ChatEmoticon/ChatEmoticonSelectBox';
import ChatEmoticonSelectPreview from '@module/components/ChatEmoticon/ChatEmoticonSelectPreview';
import { ChatTextArea } from '@module/components/ChatTextArea/ChatTextArea';
import ItemsOnUsing from '@module/components/CommonBusiness/ItemsOnUsing';
import SettingConfig from '@module/config/setting';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import useChatScrollController from '@module/helpers/chat/useChatScrollController';
import useSendChatLogicAndCommonHooks from '@module/helpers/chat/useSendChatLogicAndCommonHooks';
import { aspCond } from '@module/helpers/conditions/condition';
import useChatMessageStore from '@module/stores/useChatMessageStore';
import useChatPanelStore from '@module/stores/useChatPanelStore';
import useModalStore from '@module/stores/useModalStore';
import type { TabList } from '@module/types/broadcast-setting/type';
import IntroChat from '@pc/components/play/chat-area/chat/_components/IntroChat';
import LoginIntro from '@pc/components/play/chat-area/chat/_components/LoginIntro';
import React, { type Dispatch, type RefObject, type SetStateAction, useCallback, useState } from 'react';
import ChatEventLottie from '../_components/ChatEventLottie';
import ChatFontSizeButtons from '../_components/ChatFontSizeButtons';
// import ChattingSettingPopup from '../_components/ChattingSettingPopup';
import FirstSponEffect from '../_components/FirstSponEffect';
import SendChatToolBox from '../_components/SendChatToolBox';
import SponSummary from '../_components/SponSummary';
import VipFanListBox from '../_components/VipFanListBox';
import ChatItem from './_components/ChatItem';
import ChatListLayout from './_components/ChatListLayout';
import ScrollDownButton from './_components/ScrollDownButton';
interface Props {
  isRoomMaster: boolean;
  isManager: boolean;
  playInfo: PlayInfo;
  setStepType: Dispatch<SetStateAction<TabList>>;
  chatInputValue: string;
  setChatInputValue: React.Dispatch<React.SetStateAction<string>>;
}
function ChatContainer(t0) {
  const $ = _c(114);
  const {
    playInfo,
    isRoomMaster,
    isManager,
    setStepType,
    chatInputValue,
    setChatInputValue
  } = t0;
  const {
    isLogin,
    rawLoginState,
    isAuthDone
  } = useGetLoginInfoQuery();
  const {
    pushModal
  } = useModalStore();
  const chatMessages = useChatMessageStore(_temp);
  let t1;
  let t2;
  let t3;
  if ($[0] !== pushModal) {
    t1 = message => {
      pushModal({
        type: "CONFIRM_MODAL",
        options: {
          description: message
        }
      });
    };
    t2 = () => {
      if (aspCond.if("new-asp")) {
        SettingConfig.aspUtils?.goLogin();
        return;
      }
      pushModal({
        type: "AUTH_MODAL"
      });
    };
    t3 = () => {
      pushModal({
        type: "IDENTITY_VERIFICATION_MODAL"
      });
    };
    $[0] = pushModal;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== chatInputValue || $[5] !== setChatInputValue || $[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      chatInputValue,
      setChatInputValue,
      onFreezeOnError: t1,
      onNeedLogin: t2,
      onNeedAuthDone: t3
    };
    $[4] = chatInputValue;
    $[5] = setChatInputValue;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    chatInputRef,
    enterChat,
    handleChatInputKeyDown,
    handleChatInputClick,
    handleSubmitChat
  } = useSendChatLogicAndCommonHooks(t4);
  const {
    scrollRef,
    isNearBottom
  } = useChatScrollController();
  const {
    pcFontSize,
    setPcFontSize,
    setIsChatEmoticonSelectBoxOpen,
    isChatEmoticonSelectBoxOpen,
    selectedBlockEmoticon,
    setSelectedBlockEmoticon
  } = useChatPanelStore(_temp2);
  const [menuVisibleOffset, setMenuVisibleOffset] = useState(0);
  const isFirstSponEffectVisible = isRoomMaster;
  let t5;
  if ($[10] !== isAuthDone || $[11] !== isLogin) {
    t5 = () => {
      if (!isLogin) {
        return "\uB85C\uADF8\uC778 \uD6C4 BJ\uC5D0\uAC8C \uC778\uC0AC\uD558\uAE30";
      }
      if (!isAuthDone) {
        return "\uBCF8\uC778\uC778\uC99D \uD6C4 \uCC44\uD305 \uCC38\uC5EC\uD558\uAE30";
      }
      return "\uCC44\uD305\uD558\uAE30";
    };
    $[10] = isAuthDone;
    $[11] = isLogin;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const inputPlaceholder = t5;
  let t6;
  if ($[13] !== isAuthDone || $[14] !== isLogin) {
    t6 = () => {
      if (!isLogin) {
        return "\uB85C\uADF8\uC778";
      }
      if (!isAuthDone) {
        return "\uC778\uC99D\uD558\uAE30";
      }
    };
    $[13] = isAuthDone;
    $[14] = isLogin;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const sendButtonElem = t6;
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ChatEventLottie />;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== isFirstSponEffectVisible) {
    t8 = isFirstSponEffectVisible && <FirstSponEffect />;
    $[17] = isFirstSponEffectVisible;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = `flex h-full w-full flex-col text-[${pcFontSize}px]`;
  let t10;
  if ($[19] !== playInfo || $[20] !== setStepType) {
    t10 = <VipFanListBox playInfo={playInfo} setStepType={setStepType} />;
    $[19] = playInfo;
    $[20] = setStepType;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== isManager || $[23] !== isRoomMaster) {
    t11 = (isRoomMaster || isManager) && <SponSummary />;
    $[22] = isManager;
    $[23] = isRoomMaster;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== chatMessages.length || $[26] !== playInfo.chatMessage?.intro) {
    t12 = chatMessages.length < 100 && <IntroChat text={playInfo.chatMessage?.intro} />;
    $[25] = chatMessages.length;
    $[26] = playInfo.chatMessage?.intro;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const t13 = `${playInfo.media.userNick}님의 방송에 입장하셨습니다.`;
  let t14;
  if ($[28] !== t13) {
    t14 = <IntroChat text={t13} />;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== isLogin || $[31] !== rawLoginState) {
    t15 = rawLoginState !== undefined && !isLogin && <LoginIntro />;
    $[30] = isLogin;
    $[31] = rawLoginState;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== enterChat || $[34] !== isManager || $[35] !== isRoomMaster || $[36] !== playInfo) {
    t16 = enterChat && <ChatItem item={enterChat} playInfo={playInfo} isRoomMaster={isRoomMaster} isManager={isManager} />;
    $[33] = enterChat;
    $[34] = isManager;
    $[35] = isRoomMaster;
    $[36] = playInfo;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <ItemsOnUsing />;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== chatMessages || $[40] !== isManager || $[41] !== isRoomMaster || $[42] !== menuVisibleOffset || $[43] !== playInfo) {
    let t19;
    if ($[45] !== isManager || $[46] !== isRoomMaster || $[47] !== menuVisibleOffset || $[48] !== playInfo) {
      t19 = (item, index) => <React.Fragment key={"offset" in item && item.offset || "data" in item && "created_at" in item.data && item.data.created_at || index}><ChatItem item={item} userIdx={playInfo.media.userIdx} playInfo={playInfo} isRoomMaster={isRoomMaster} isManager={isManager} menuVisibleOffset={menuVisibleOffset} setMenuVisibleOffset={setMenuVisibleOffset} /></React.Fragment>;
      $[45] = isManager;
      $[46] = isRoomMaster;
      $[47] = menuVisibleOffset;
      $[48] = playInfo;
      $[49] = t19;
    } else {
      t19 = $[49];
    }
    t18 = chatMessages.map(t19);
    $[39] = chatMessages;
    $[40] = isManager;
    $[41] = isRoomMaster;
    $[42] = menuVisibleOffset;
    $[43] = playInfo;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[50] !== scrollRef || $[51] !== t12 || $[52] !== t14 || $[53] !== t15 || $[54] !== t16 || $[55] !== t18) {
    t19 = <ChatListLayout scrollRef={scrollRef}>{t12}{t14}{t15}{t16}{t17}{t18}</ChatListLayout>;
    $[50] = scrollRef;
    $[51] = t12;
    $[52] = t14;
    $[53] = t15;
    $[54] = t16;
    $[55] = t18;
    $[56] = t19;
  } else {
    t19 = $[56];
  }
  let t20;
  if ($[57] !== chatInputRef || $[58] !== isLogin) {
    t20 = () => {
      if (isLogin) {
        return;
      }
      chatInputRef.current?.blur();
    };
    $[57] = chatInputRef;
    $[58] = isLogin;
    $[59] = t20;
  } else {
    t20 = $[59];
  }
  let t21;
  if ($[60] !== isNearBottom || $[61] !== scrollRef) {
    t21 = !isNearBottom && <ScrollDownButton onClick={() => {
      if (!scrollRef.current) {
        return;
      }
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }} />;
    $[60] = isNearBottom;
    $[61] = scrollRef;
    $[62] = t21;
  } else {
    t21 = $[62];
  }
  let t22;
  if ($[63] !== selectedBlockEmoticon || $[64] !== setSelectedBlockEmoticon) {
    t22 = selectedBlockEmoticon && <ChatEmoticonSelectPreview onClose={() => {
      setSelectedBlockEmoticon(null);
    }} selectedBlockEmoticon={selectedBlockEmoticon} />;
    $[63] = selectedBlockEmoticon;
    $[64] = setSelectedBlockEmoticon;
    $[65] = t22;
  } else {
    t22 = $[65];
  }
  let t23;
  if ($[66] !== setPcFontSize) {
    t23 = <ChatFontSizeButtons setPcFontSize={setPcFontSize} />;
    $[66] = setPcFontSize;
    $[67] = t23;
  } else {
    t23 = $[67];
  }
  let t24;
  if ($[68] !== isRoomMaster || $[69] !== playInfo) {
    t24 = playInfo.media.code && <SendChatToolBox playInfo={playInfo} isRoomMaster={isRoomMaster} mediaCode={playInfo.media.code} />;
    $[68] = isRoomMaster;
    $[69] = playInfo;
    $[70] = t24;
  } else {
    t24 = $[70];
  }
  let t25;
  if ($[71] !== t23 || $[72] !== t24) {
    t25 = <div className="mb-[8px] flex w-full items-center justify-between border-0 bg-transparent text-[#dfe2ea]">{t23}{t24}</div>;
    $[71] = t23;
    $[72] = t24;
    $[73] = t25;
  } else {
    t25 = $[73];
  }
  const t26 = chatInputRef as RefObject<HTMLTextAreaElement | null>;
  let t27;
  if ($[74] !== handleSubmitChat) {
    t27 = () => handleSubmitChat();
    $[74] = handleSubmitChat;
    $[75] = t27;
  } else {
    t27 = $[75];
  }
  const t28 = inputPlaceholder();
  let t29;
  if ($[76] !== isAuthDone || $[77] !== isChatEmoticonSelectBoxOpen || $[78] !== isLogin || $[79] !== setIsChatEmoticonSelectBoxOpen) {
    t29 = isLogin && isAuthDone && !aspCond.if("asp") && !SettingConfig.isProd ? () => {
      setIsChatEmoticonSelectBoxOpen(!isChatEmoticonSelectBoxOpen);
    } : undefined;
    $[76] = isAuthDone;
    $[77] = isChatEmoticonSelectBoxOpen;
    $[78] = isLogin;
    $[79] = setIsChatEmoticonSelectBoxOpen;
    $[80] = t29;
  } else {
    t29 = $[80];
  }
  let t30;
  if ($[81] !== sendButtonElem) {
    t30 = sendButtonElem();
    $[81] = sendButtonElem;
    $[82] = t30;
  } else {
    t30 = $[82];
  }
  let t31;
  if ($[83] !== chatInputValue || $[84] !== handleChatInputClick || $[85] !== handleChatInputKeyDown || $[86] !== setChatInputValue || $[87] !== t26 || $[88] !== t27 || $[89] !== t28 || $[90] !== t29 || $[91] !== t30) {
    t31 = <ChatTextArea ref={t26} value={chatInputValue} onValueChange={setChatInputValue} onSubmit={t27} placeholder={t28} onClick={handleChatInputClick} onKeyDown={handleChatInputKeyDown} minRows={1} maxRows={2} onEmojiClick={t29} sendButtonElem={t30} />;
    $[83] = chatInputValue;
    $[84] = handleChatInputClick;
    $[85] = handleChatInputKeyDown;
    $[86] = setChatInputValue;
    $[87] = t26;
    $[88] = t27;
    $[89] = t28;
    $[90] = t29;
    $[91] = t30;
    $[92] = t31;
  } else {
    t31 = $[92];
  }
  let t32;
  if ($[93] !== t20 || $[94] !== t21 || $[95] !== t22 || $[96] !== t25 || $[97] !== t31) {
    t32 = <div className="relative w-full border-t p-[12px]" onClick={t20}>{t21}{t22}{t25}{t31}</div>;
    $[93] = t20;
    $[94] = t21;
    $[95] = t22;
    $[96] = t25;
    $[97] = t31;
    $[98] = t32;
  } else {
    t32 = $[98];
  }
  let t33;
  if ($[99] !== isChatEmoticonSelectBoxOpen || $[100] !== playInfo.media.userIdx || $[101] !== setIsChatEmoticonSelectBoxOpen || $[102] !== setSelectedBlockEmoticon) {
    t33 = !aspCond.if("asp") && !SettingConfig.isProd && isChatEmoticonSelectBoxOpen && <ChatEmoticonSelectBox onClose={() => {
      setIsChatEmoticonSelectBoxOpen(false);
    }} userIdx={playInfo.media.userIdx} onSelect={item_0 => {
      setSelectedBlockEmoticon(item_0);
    }} />;
    $[99] = isChatEmoticonSelectBoxOpen;
    $[100] = playInfo.media.userIdx;
    $[101] = setIsChatEmoticonSelectBoxOpen;
    $[102] = setSelectedBlockEmoticon;
    $[103] = t33;
  } else {
    t33 = $[103];
  }
  let t34;
  if ($[104] !== t10 || $[105] !== t11 || $[106] !== t19 || $[107] !== t32 || $[108] !== t33 || $[109] !== t9) {
    t34 = <div className={t9}>{t10}{t11}{t19}{t32}{t33}</div>;
    $[104] = t10;
    $[105] = t11;
    $[106] = t19;
    $[107] = t32;
    $[108] = t33;
    $[109] = t9;
    $[110] = t34;
  } else {
    t34 = $[110];
  }
  let t35;
  if ($[111] !== t34 || $[112] !== t8) {
    t35 = <section className="relative h-full w-full flex-1 flex-col">{t7}{t8}{t34}</section>;
    $[111] = t34;
    $[112] = t8;
    $[113] = t35;
  } else {
    t35 = $[113];
  }
  return t35;
}
function _temp2(state_0) {
  return {
    pcFontSize: state_0.pcFontSize,
    setPcFontSize: state_0.setPcFontSize,
    setIsChatEmoticonSelectBoxOpen: state_0.setIsChatEmoticonSelectBoxOpen,
    isChatEmoticonSelectBoxOpen: state_0.isChatEmoticonSelectBoxOpen,
    setIsChattingSettingOpen: state_0.setIsChattingSettingOpen,
    selectedBlockEmoticon: state_0.selectedBlockEmoticon,
    setSelectedBlockEmoticon: state_0.setSelectedBlockEmoticon
  };
}
function _temp(state) {
  return state.chatMessages;
}
export default ChatContainer;